import { render } from "./AppMessage.vue?vue&type=template&id=59606ebb"
import script from "./AppMessage.vue?vue&type=script&lang=js"
export * from "./AppMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__